import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { Colors, Typography } from "../../shared/theme/styles.enum";

export const useStyles = (drawerSize?: number) =>
  makeStyles((theme: Theme) =>
    createStyles({
      list: {
        width: drawerSize || 800,
        '@media (max-width:768px)': {
          width: '100vw',
        },
      },
      fullList: {
        width: "auto",
      },
      transferButton: {
        padding: "6px 20px",
        width: "max-content",
        height: 42,
        backgroundColor: theme.palette.primary.main,
        color: Colors.White,
        borderRadius: 21,
        fontSize: "1.125rem",
        fontFamily: Typography.FontFamily2,
        fontWeight: 600,
        textAlign: "center",
        textTransform: "none",
        boxShadow: '0 2px 8px rgba(63,167,149,0.3)',
        transition: 'all 0.2s ease',
        "&:hover": {
          backgroundColor: theme.palette.primary.main,
          boxShadow: '0 4px 16px rgba(63,167,149,0.4)',
          transform: 'translateY(-1px)',
        },
      },
    })
  );
